import { IeLynxObject } from "../../common/models/eLynxObject";


export const keys = {
    all: ["object"],
    attributes: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "attributes", {
            groupID,
            eLynxObject
        }
    ],
    customerAttributes: (contextGroupID: number) => [
        ...keys.all,
        "customer-attributes", {
            contextGroupID
        }
    ]
};
